(function () {       
    function initBuyButtons(root) {
        const qtyInput = root.querySelector('.quantity__input');
        const button = root.querySelector('[id^="ProductSubmitButton"]');
        const priceEl = button?.querySelector('.button-price');

        if (!qtyInput || !button || !priceEl) return;

        // Prevent double init
        if (button.dataset.buyInit === "true") return;
        button.dataset.buyInit = "true";

        let qty = parseInt(qtyInput.value || 1, 10);
        let basePrice = getBasePrice();

        // =========================
        // GET BASE PRICE FROM DOM
        // =========================
        function getBasePrice() {
            const priceContainer = root.querySelector('.product-price');
            if (!priceContainer) return 0;

            const priceEl = priceContainer.querySelector(
                '.price-item--sale, .price-item--regular'
            );

            const raw = priceEl?.textContent || '';
            const numeric = parseFloat(raw.replace(/[^0-9.]/g, ''));

            return isNaN(numeric) ? 0 : numeric * 100;
        }

        // =========================
        // FORMAT MONEY
        // =========================
        function formatMoney(cents) {
            return (cents / 100).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });
        }

        // =========================
        // UPDATE BUTTON PRICE
        // =========================
        function updateButtonPrice() {
            const total = basePrice * qty;
            priceEl.textContent = formatMoney(total);
        }

        // =========================
        // UPDATE QUANTITY
        // =========================
        function updateQuantity() {
            qty = parseInt(qtyInput.value || 1, 10);

            // refresh base price in case variant changed
            basePrice = getBasePrice();

            updateButtonPrice();
        }

        // =========================
        // BIND LISTENERS
        // =========================
        function bindQuantityListeners() {
            qtyInput.addEventListener('input', updateQuantity);
            qtyInput.addEventListener('change', updateQuantity);
            qtyInput.addEventListener('keyup', updateQuantity);

            // catches JS-driven updates (Shopify + apps)
            const observer = new MutationObserver(updateQuantity);

            observer.observe(qtyInput, {
                attributes: true,
                attributeFilter: ['value']
            });
        }

        bindQuantityListeners();

        // =========================
        // VARIANT / TYPE CHANGE
        // =========================
        root.querySelectorAll('input[name="Type"]').forEach(radio => {
            radio.addEventListener('change', () => {
                setTimeout(() => {
                    basePrice = getBasePrice();
                    qty = 1;
                    updateButtonPrice();
                }, 50);
            });
        });

        // init
        updateButtonPrice();
    }

    // =========================
    // INIT (product or quick add)
    // =========================
    if (!window.location.pathname.includes('/products/')) {
        const quickAddModal = document.currentScript?.closest('.quick-add-modal');
        initBuyButtons(quickAddModal);
    } else {
        const root = document.querySelector('product-info')
        initBuyButtons(root);
    }
})();
